import { Home } from "@/features/home/home";

export const Route = createFileRoute({
  component: Home,
});

/*
function RouteComponent() {
  const memberships = useUserStore((state) => state.memberships);
  const [active] = useOrganization();

  // If there is only a single organization we should just redirect to it
  if (memberships.length === 0) {
    return <Navigate to="/$orgId" params={{ orgId: memberships[0].id }} />;
  }

  // Check cookies for current_organization
  if (active) {
    return <Navigate to="/$orgId" params={{ orgId: active.id }} />;
  }

  // No organization could be found, redirect to the users account
  // so they can set it up and join/create a new organization
  return <Navigate to="/account" />;
}
*/
